(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    function updateMenuTopPosition() {
    const trigger = document.querySelector('sticky-header');
    const submenus = document.querySelectorAll('.header__submenu');
    const pos = trigger.getBoundingClientRect().height + trigger.getBoundingClientRect().top;
    // console.log(pos,window.scrollY,trigger.getBoundingClientRect())
    for (const menu of submenus) {
      menu.style.top = `${pos}px`;
    }
  }

  window.addEventListener('scroll', updateMenuTopPosition);
  window.addEventListener('resize', updateMenuTopPosition);
  window.addEventListener('load', updateMenuTopPosition);

  // close all other opened submenus
  for (const details of document.querySelectorAll('[data-desktop-level] details')) {
    details.addEventListener('click', (e) => {
      const el = e.currentTarget || e.target;
      for (const submenu of document.querySelectorAll('[data-desktop-level="two"] details[open]')) {
        if (submenu.id !== details.id) {
          submenu.removeAttribute('open');
        }
      }
    });
  }
  (async () => {
    updateMenuTopPosition();
  })();
  } catch(e) { console.error(e); }
})();

})();
